import { render, staticRenderFns } from "./EadStatus.vue?vue&type=template&id=2b82467f&scoped=true&"
import script from "./EadStatus.vue?vue&type=script&lang=ts&"
export * from "./EadStatus.vue?vue&type=script&lang=ts&"
import style0 from "./EadStatus.vue?vue&type=style&index=0&id=2b82467f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b82467f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
